module.exports = __webpack_public_path__ + "img/examenpun.72936df5.png";